export default __webpack_public_path__ + "static/media/warning--junction-with-a-side-road-perpendicular-right--g1.c806e5b6.png";